<template>
  <div class="container px-0">
    <div class="row mb-2">
      <!-- <div class="col-8">
        <h2 class="typo-h5 ">New Video</h2>
      </div>
      <div class="col-4">
        <h2 class="typo-h5 ">Recommended</h2>
      </div>-->
      <div class="col-12 typo-h5 flex-v-center breadcrumb row px-3">
        <router-link class="rl" :to="{ name: 'Tutorials' }">{{$t("generals.tutorials")}}</router-link>
        <!-- <span></span> -->
        <i class="icon icon-arrow-right"></i>
        <!-- <router-link class="rl" :to="{ name: 'Topics' }">Topic</router-link>
        <i class="icon icon-arrow-right"></i>-->
        <span v-if="currentTopic">{{currentTopic.snippet.title}}</span>
      </div>
    </div>
    <div class="bb1sg"></div>

    <template v-if="$route.query.watch">
      <Watch :topic="currentTopic" :playlist="playlist" :video="currentVideo" @watch="watchVideo" />
    </template>
    <template v-else>
      <Overview :topic="currentTopic" :playlist="playlist" @watch="watchVideo" />
    </template>
  </div>
</template>

<script>
import Watch from "./Watch";
import Overview from "./Overview";
import { mapState, mapActions, mapMutations } from "vuex";
import * as TYPES from "@/store/tutorial/types.js";
export default {
  name: "TopicDetails",
  components: {
    Watch,
    Overview
  },
  data() {
    return {
      playlist: [],
      currentVideo: null
    };
  },
  computed: {
    ...mapState({
      topics: state => state.tutorial.topic.list,
      allPlaylist: state => state.tutorial.playlist
    }),
    currentTopic() {
      let id = this.$route.params.id;
      if (id) {
        let topic = this.topics.find(item => item.id === id);
        if (topic) {
          topic = JSON.parse(JSON.stringify(topic));
          topic.title = this.$t(topic.title);
          topic.describes = this.$t(topic.describes);
          return topic;
        }
      }
      return null;
    }
  },
  watch: {
    allPlaylist: {
      deep: true,
      immediate: true,
      handler(newV) {
        if (this.currentTopic) this.playlist = newV[this.currentTopic.id] || [];
        if (this.playlist && this.$route.query.watch) {
          this.watchWithID(this.$route.query.watch);
        }
      }
    },
    currentTopic() {
      this.checkTopic();
    },
    "$route.query.watch"(newV, oldV) {
      if (newV == oldV) return;
      this.watchWithID(newV);
    }
  },
  beforeMount() {
    this.checkTopic();
  },
  methods: {
    ...mapActions({
      getPlaylist: "tutorial/tutorialGetPlaylist"
    }),
    ...mapMutations({
      setTopic: `tutorial/${TYPES.mutations.TUTORIAL_SET_TOPIC}`
    }),
    watchVideo(item) {
      this.$router.push({ name: "TopicDetails", query: { watch: item.id } });
      this.currentVideo = item;
    },
    watchWithID(id) {
      if (!id) return;
      let video = this.playlist.find(item => item.id == id);
      this.currentVideo = video;
    },
    checkTopic() {
      let topic = this.currentTopic;
      if (this.topics && this.topics.length)
        if (!topic) this.$router.push({ name: "Topics" });
      if (topic) {
        this.getPlaylist(topic.id);
        this.playlist = this.allPlaylist[this.currentTopic.id] || [];
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.bb1sg {
  border-bottom: 1px solid $grey3;
}
</style>
